import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import {
    DownloadButtonGroup,
    ResetFiltersButton,
    DelayedApplyFilterButtonGroup,
    BarPieButtonGroup,
    OrgDesignSidebarComponent,
    CurrentOnlyCheckbox,
} from 'search-new/components/Visualization/VisualizationSidebars/SidebarButtons'

import {
    VisualizationResultsTable
} from 'search-new/components/Visualization/VisualizationSidebars/SidebarTables'

import { barPieProps } from "search-new/selectors"

const UnconnectedBarPieSidebar = (props) => {
    return (
        <div className="sidebar-controls">
            <VisualizationResultsTable
                uniqueFlvId={props.uniqueFlvId}
                uniqueVizSceneId={props.uniqueVizSceneId}
                label={props.sidebarTableLabel || "Results"}
                tooltipText="Select items by clicking the graph or table elements and then click 'Apply Selected' to refine visualization"
                noConnectedFilter={!props.vizFilterId}
                data={props.currentOnlyTableData}
            />
            {
                props.showCurrentToggle &&
                <CurrentOnlyCheckbox
                    uniqueFlvId={props.uniqueFlvId}
                    uniqueVizSceneId={props.uniqueVizSceneId}
                    disabled={props.disableButtons}
                />
            }
            <DelayedApplyFilterButtonGroup
                uniqueFlvId={props.uniqueFlvId}
                uniqueVizSceneId={props.uniqueVizSceneId}
                disabled={props.disableButtons}
            />
            <ResetFiltersButton
                uniqueFlvId={props.uniqueFlvId}
                uniqueVizSceneId={props.uniqueVizSceneId}
                disabled={props.disableButtons}
            />
            <BarPieButtonGroup
                uniqueFlvId={props.uniqueFlvId}
                uniqueVizSceneId={props.uniqueVizSceneId}
                disabled={props.disableButtons}
            />
            {
                !props.noOrgDesign &&
                <OrgDesignSidebarComponent
                    uniqueFlvId={props.uniqueFlvId}
                    uniqueVizSceneId={props.uniqueVizSceneId}
                />
            }
            <DownloadButtonGroup
                uniqueFlvId={props.uniqueFlvId}
                uniqueVizSceneId={props.uniqueVizSceneId}
                disabled={props.disableButtons}
            />
        </div>
    )
}

export default connect(barPieProps, null)(UnconnectedBarPieSidebar)

UnconnectedBarPieSidebar.propTypes = {
    uniqueFlvId: PropTypes.string.isRequired,
    uniqueVizSceneId: PropTypes.string.isRequired,
    isVisualizationLoading: PropTypes.bool.isRequired,
    disableButtons: PropTypes.bool,
    sidebarTableLabel: PropTypes.string,
    vizFilterId: PropTypes.string,
    // from connection
    currentOnlyData: PropTypes.object,
}
